import S_base from '@/services/wasaapi/__base';

export default {
  release(announcementId) {
    return S_base.create({
      parentName: 'announcement',
      parentId: announcementId,
      modelName: 'release',
    });
  },
};